import { Component,  OnInit,  Renderer2,  ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DataTableDirective } from 'angular-datatables';
declare var $: any;
import * as _ from 'lodash';
import { Subject } from 'rxjs';
import { CommonFunction } from 'src/app/helpers/commonFunction';
import { CategoryMasterService } from 'src/app/services/category-master.service';
import { AlertComponent } from '../../alert/alert.component';
import { CustomValidation } from 'src/app/helpers/customValidation';
import { environment } from 'src/environments/environment';
import { LoaderService } from 'src/app/services/loader.service';
@Component({
  selector: 'app-agenda-categories',
  templateUrl: './agenda-categories.component.html',
  styleUrls: ['./agenda-categories.component.css']
})
export class AgendaCategoriesComponent implements OnInit {

  public environmentSettings: any;

  @ViewChild(DataTableDirective)
  dtElement: DataTableDirective;
  dtOptions: DataTables.Settings = {};
  dtOptions2: DataTables.Settings = {};
  categories: any[];
  categoryId: string;
  meetingTypes: any;
  categoryMasterForm: FormGroup;
  dtTrigger: Subject<any> = new Subject();
  error: any = { isError: false, errorMessage: '' };
  editGlobalCategory: boolean;
  MeetingTypeName: any;
  addCategoryDisabledOnclick: boolean = false;
  constructor(private categoryMasterService: CategoryMasterService,
    private alert: AlertComponent,
    private customValidation: CustomValidation,
    private commonFunction: CommonFunction,
    private renderer: Renderer2,
    private loaderService: LoaderService) { }

  ngOnDestroy(): void {
    // Re-enable loader when navigating away from this component
    this.loaderService.enable();
  }


  ngOnInit() {

    this.environmentSettings = environment;

    this.commonFunction.validateURL('Category', '');
    this.initialiseJqueryEvents();

    // this.commonFunction.removeDataTableSaveStateKey("categoryTable");

    this.getCategoryList();

    this.getMeetingTypeList();

    this.dtOptions = {
      destroy: true,
      scrollY: "430px",
      scrollX: true,
      deferRender: true,
      scrollCollapse: true,
      stateSave: true,
      stateDuration: -1,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 10,
      search: true,
      order: [0, 'asc'],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      columnDefs: [{ orderable: false, targets: [3] }]
    };

    this.categoryMasterForm = new FormGroup({
      CategoryName: new FormControl('', [Validators.required, Validators.maxLength(100),
      this.customValidation.noWhitespaceValidator
      ]),
      IsGlobal: new FormControl('', [Validators.required]),
      isDefault: new FormControl('', [Validators.required]),
      MeetingType: new FormControl('', [Validators.required])
    });

    this.categoryMasterForm.controls.MeetingType.setValue('');
    var token = localStorage.getItem('token')
    var self=this;
    this.dtOptions2 = {
      ajax: {
        url: environment.pssServerUrl + "dataTable/categoryMaster/" + JSON.parse(localStorage.getItem("companyDetails")).companyID,
        type: 'get',
        headers: { "x-access-token": token },
        cache: true
      },
      columns: [{
        title: 'Category Name',
        render: function (data: any, type: any, full: any) {
          return full.CategoryName
        }
      },
      {
        title: 'Meeting Type',
        render: function (data: any, type: any, full: any) {
          if (full.MeetingTypeID.MeetingTypeName) {
            return full.MeetingTypeID.MeetingTypeName
          } else {
            return full.MeetingTypeID.MeetingType
          }
        }
      },
      {
        title: 'Company / Global',
        render: function (data: any, type: any, full: any) {
          if (full.IsGlobal) {

            return 'Global'
          } else {
            return 'Company Specific'
          }
        }
      },
      {
        title: 'Default / Not Default',
        render: function (data: any, type: any, full: any) {
          if (full.isDefault) {

            return 'Yes'
          } else {
            return 'No'
          }
        }
      },
      {
        title: 'Action',
        render: function (data: any, type: any, full: any) {
          if (self.commonFunction.validateModulePermitions('Category', '/category/edit?goveva=true&email=')) {
            return '<button [appHasPermission]="{Url: /category/edit?goveva=true&email=, method:put, menu: Category}" type="button"  update-category=' + full._id + ' class="btn-sm btn btn-warning" ><span class="fa fa-pencil"  update-category=' + full._id + '></span></button>&nbsp;&nbsp;<button [appHasPermission]="{Url: /category/edit?goveva=true&email=, method:put, menu: Category}" type="button" delete-category=' + full._id + ' class="btn-sm btn btn-danger" ><span class="icmn-bin"  delete-category=' + full._id + '></span></button>';
          } else {
            return '';
          }

        }
      }],
      processing: true,
      serverSide: false,
      destroy: true,
      scrollY: "430px",
      scrollX: true,
      deferRender: true,
      scrollCollapse: true,
      stateSave: true,
      stateDuration: -1,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 10,
      search: true,
      order: [0, 'asc'],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      columnDefs: [{ orderable: false, targets: [3] }],
      dom: 'lBfrtip',//'Bfrtip',
      // Configure the buttons
      buttons: [
        {
          text: '<i class="fa fa-files-o"></i> Export to Excel',
          className: 'btn btn-sm btn-warning export-btn',
          filename: 'Agenda Category List',
          title: 'Agenda Category List',
          extend: 'excel',
          exportOptions: {
            columns: [0, 1, 2],
            format: {
              body: function ( data, row, column, node ) {
                  if(data.includes("+") || data.includes("@") || data.includes("=") || data.includes("|") || data.includes("!")){
                    if(data.match(/^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+[.]+[a-zA-Z0-9.-]+$/)){  return data }else{ return  "'" + data + "'"; }
                  }else{ return data }
                }
            }
          }

        }
      ]
    };
  }

  ngAfterViewInit(): void {
    this.renderer.listen('document', 'click', (event) => {
      if (event.target.hasAttribute("update-category")) {
        console.log(event.target.getAttribute("update-category"));
        this.loadCategoryToEdit(event.target.getAttribute("update-category"))
        // this.loadcategoryByIdToEdit(event.target.getAttribute("update-category"))
        // this.showCommitteeUpdatePopUp( event.target.getAttribute("update-committee"))
      }
      if (event.target.hasAttribute("delete-category")) {
        console.log(event.target.getAttribute("delete-category"));
        this.deleteConfirmation(event.target.getAttribute("delete-category"))
        //  this.showDeleteConfirmationPopUp(event.target.getAttribute("delete-category"))
      }
    });
  }

  IsGlobalType(item: any) {
    let isGlobal = item;
    this.meetingTypes = [];
    // console.log("item",item);
    if (isGlobal === "Yes") {

      this.categoryMasterService.getMeetingTypeList()
        .subscribe(meetingTypeList => {
          if (meetingTypeList.status == 0) {
            var self = this;

            // var meetingTypesData = _.filter(meetingTypeList.meetingTypeList, function (obj) { return obj.CompanyID == null });

            this.meetingTypes = this.commonFunction.sortByKey(meetingTypeList.meetingTypeList, "MeetingType");
            _.filter(self.meetingTypes, function (obj, index) {
              if (obj) {
                if (obj.Committee && obj.Committee.CommitteeName == 'Other') {
                  self.meetingTypes.splice(index, 1);
                }
              }
            })
          }
        })


    } else {
      this.categoryMasterService.getMeetingTypeList()
        .subscribe(meetingTypeList => {
          if (meetingTypeList.status == 0) {

            this.meetingTypes = this.commonFunction.sortByKey(meetingTypeList.meetingTypeList, "MeetingType");
          }
        })

    }



  }


  getCategoryList() {
    this.categories = [];
    this.categoryMasterService.getCategoryList()
      .subscribe(categoryList => {
        if (categoryList.status == 0) {
          this.categories = categoryList.categoryList;
          this.dtTrigger.next();
        }
      });
  }

  addCategory() {
    if (this.categoryMasterForm.status == "VALID") {
      var checkGlobal = true;
      this.addCategoryDisabledOnclick=true;
      var checkDefault = true;
      if (this.categoryMasterForm.controls.IsGlobal.value == 'Company') {
        checkGlobal = false;
      }
      if (this.categoryMasterForm.controls.isDefault.value == 'false') {
        checkDefault = false;
      }
      var newCategory = {
        IsGlobal: checkGlobal,
        isDefault: checkDefault,
        CategoryName: this.categoryMasterForm.controls.CategoryName.value.trim(),
        MeetingTypeID: this.categoryMasterForm.controls.MeetingType.value
      }
      console.log("newCategory ", newCategory);

      this.categoryMasterService.addCategory(newCategory)
        .subscribe(category => {
          this.addCategoryDisabledOnclick = false;
          if (category.status == 0) {
            $('#categoryDialog').modal('toggle');
            $('#categoryDataTable').DataTable().ajax.reload();
            this.alert.success("Category created successfully.");
            // if (this.dtElement.dtInstance != undefined) {
            //   this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            //     dtInstance.destroy();
            //   });
            // }
            this.getCategoryList();
          } else {
            $('#categoryDialog').modal('toggle');
            // this.alert.error(category.message);
            this.alert.error( JSON.stringify(category.message));
          }
          this.categoryMasterForm.reset();

        });
    }
    else {
      console.log('Invalid form submit.')
      return false;
    }
  }

  editCategory() {
    if (this.categoryMasterForm.valid) {
      this.addCategoryDisabledOnclick = true;
  
      const checkGlobal = this.categoryMasterForm.controls.IsGlobal.value !== 'Company';
      const checkDefault = this.categoryMasterForm.controls.isDefault.value !== 'false';
  
      const updatedCategory: any = {
        _id: this.categoryId,
        CategoryName: this.categoryMasterForm.controls.CategoryName.value.trim(),
        IsGlobal: checkGlobal,
        isDefault: checkDefault,
        MeetingTypeID: this.categoryMasterForm.controls.MeetingType.value,
        IsPredefined: false // <--- safe, static boolean
      };
      
  
      console.log('updatedCategory', updatedCategory);
  
      this.categoryMasterService.updateCategory(updatedCategory).subscribe({
        next: (res: any) => {
          this.addCategoryDisabledOnclick = false;
          $('#categoryDialog').modal('toggle');
      
          if (res.status === 0) {
            this.alert.success("Category updated successfully.");
            this.messagePopUpTimeoutToogle();
          } else {
            console.error("Backend responded with error:", res);
            const msg = res.err_fields
              ? `${JSON.stringify(res.err_fields)} fields are required or invalid.`
              : res.message || 'Unknown error';
            this.alert.error(msg);
          }
      
          this.categoryMasterForm.reset();
          $('#categoryDataTable').DataTable().ajax.reload();
        },
        error: (err) => {
          this.addCategoryDisabledOnclick = false;
          $('#categoryDialog').modal('toggle');
          console.error("Update failed (HTTP error):", err);
          this.alert.error(err.error?.message || "Oops! Something went wrong while updating the category.");
        }
      });
      
  
    } else {
      console.warn('Invalid form submission');
      return false;
    }
  }
  

  loadCategoryToEdit(categoryId) {
    this.loaderService.disable();
    this.editGlobalCategory = true;
    this.categoryMasterService.getCategoryById(categoryId)
      .subscribe(category => {
        if (category.status == 0) {

          this.categoryId = category.categoryList[0]._id;
          this.categoryMasterForm.controls.CategoryName.setValue(category.categoryList[0].CategoryName);
          this.categoryMasterForm.controls.MeetingType.setValue(category.categoryList[0].MeetingTypeID);
          this.MeetingTypeName = category.categoryList[0].MeetingTypeName;
          if (this.MeetingTypeName == undefined) {
            this.getMeetingNameById();
          }
          if (category.categoryList[0].IsGlobal) {
            this.categoryMasterForm.controls.IsGlobal.setValue('Global');
          }
          else {
            this.categoryMasterForm.controls.IsGlobal.setValue('Company');
          }
          if (category.categoryList[0].isDefault) {
            this.categoryMasterForm.controls.isDefault.setValue('true');
          } else {
            this.categoryMasterForm.controls.isDefault.setValue('false');
          }
          $("#myModalLabel").html('<i class="fa fa-pencil"></i>Edit Category Master');
          $('#btnsaveCategory').hide();
          $('#btnupdateCategory').show();
          $('#categoryTypeGlobal').prop("disabled", true);
          $('#categoryTypeCompany').prop("disabled", true);
          // $('#isDefaultYes').prop("disabled", true);
          // $('#isDefaultNo').prop("disabled", true);
          this.error = { isError: false, errorMessage: '' }
          $('#categoryDialog').modal('toggle') //
        }

      });
  }



  deleteConfirmation(categoryId) {
    this.categoryId = categoryId
    $('#confirmation').modal('toggle');
  }

  deleteCategory() {
    this.categoryMasterService.deleteCategory(this.categoryId).subscribe(data => {
      if (data.status == 0) {
        this.alert.success(data.message);
        $('#categoryDataTable').DataTable().ajax.reload();
        $('#confirmation').modal('toggle');
      }
      else {
        this.alert.error(data.message);
        $('#categoryDataTable').DataTable().ajax.reload();
        $('#confirmation').modal('toggle');
      }
      // this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      //   dtInstance.destroy();
      // });
      // this.getCategoryList();
    });

  }

  messagePopUpTimeoutToogle() {
    setTimeout(function () {
      var popUpClass = $('#messagePopUp').attr('class');
      if (popUpClass == "modal fade show") {
        $('#messagePopUp').modal('toggle');
      }
    }, 3000);
  }

  showAddPopUp() {
    $('#categoryDialog').modal('toggle');
    this.editGlobalCategory = false;
    $("#myModalLabel").html('<i class="fa fa-plus"></i>Add Category Master');
    $('#btnsaveCategory').show();
    $('#btnupdateCategory').hide();
    $('#categoryTypeGlobal').prop("disabled", false);
    $('#categoryTypeCompany').prop("disabled", false);
    $('#selectMeetingType').prop("disabled", false);
    // $('#isDefaultYes').prop("disabled", false);
    // $('#isDefaultNo').prop("disabled", false);
    this.categoryMasterForm.reset();
    this.categoryId = "";
    this.categoryMasterForm.controls.CategoryName.setValue('');
    this.categoryMasterForm.controls.IsGlobal.setValue('Company');
    this.categoryMasterForm.controls.isDefault.setValue('false');
    this.categoryMasterForm.controls.MeetingType.setValue('');
    this.error = { isError: false, errorMessage: '' }
  }

  getMeetingTypeList() {
    this.meetingTypes = [];
    this.categoryMasterService.getMeetingTypeList()
      .subscribe(meetingTypeList => {
        if (meetingTypeList.status == 0) {
          this.meetingTypes = this.commonFunction.sortByKey(meetingTypeList.meetingTypeList, "MeetingType");
        }
      })
  }

  getMeetingNameById() {
    let meetingTypeId = this.categoryMasterForm.controls.MeetingType.value;
    this.categoryMasterService.getMeetingNameById(meetingTypeId)
      .subscribe(res => {
        if (res.status == 0) {
          let meetingTypeName = res.meetingDetails[0].MeetingType;
          $("#meetingTypeName").val(meetingTypeName);
          $('#meetingTypeName').prop("disabled", true);
        }
      })
  }

  initialiseJqueryEvents() {

    $('.modal-dialog').draggable({
      handle: ".modal-header"
    });

    $('#categoryDialog').on('shown.bs.modal', function (e) {
      $('#categoryTypeGlobal').focus();
    });

  }

}

